module.exports = __webpack_public_path__ + "img/brush/brush@2x.png";


//////////////////
// WEBPACK FOOTER
// ./img/brush/brush@2x.png
// module id = 61
// module chunks = 3